// Example file - fill values with your local changes and rename this file to
// localConfig.js to enable it.
export default {
  port: 8090,
/*  url: 'http://localhost:8090',
  ssrUrl: 'http://localhost:8090',
  apiUrl: 'http://localhost:8090',
*/
  /*
  // pro debug build android aplikace, build je treba delat s Java verzi 8
  url: 'http://192.168.0.107:8090',
  ssrUrl: 'http://192.168.0.107:8090',
  apiUrl: 'http://192.168.0.107:8090',*/


  // pro release build android aplikace je potreba nastavit http misto https
  url: 'https://eda.dopravniakademie.cz',
  ssrUrl: 'https://eda.dopravniakademie.cz',
  apiUrl: 'https://eda.dopravniakademie.cz',

  jwt: {
    secret: '22NIo6n=[067tVoq80dK1:0jVFA])V=Qe4X~=1@@Gf<3+3wTT1[{-85.1o}m*',
    algorithm: 'HS512',
  },
  notifications: {
    from: 'notifikace@dopravniakademie.cz',
    replyTo: 'centrala@dopravni-akademie.cz'
  },
  smtp: {
    auth: {
      pass: "CpO8tubRWEsl+6S",
      user: "notifikace@dopravniakademie.cz"
    },
    host: "smtp.zoner.com",
    port: 465,
    secure: true
  },
  remoteHotReload: false,
  dbUrl: 'mongodb://host.docker.internal:27020/eda',
}



// WEBPACK FOOTER //
// ./src/server/localConfig.js